export default __webpack_public_path__ + "static/media/ar.159c880e.svg";